import React from "react";
import { useField } from "formik";
import MultiSelectBox from "../MultiSelectBox";

const FormMultiSelectBox = ({ name, onChange = null, ...rest }) => {
  const [field, meta, helpers] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  return (
    <MultiSelectBox
      selectedValues={field.value || []}
      onChange={onChange ?? helpers.setValue}
      error={getError()}
      {...rest}
    />
  );
};

export default FormMultiSelectBox;
